import { hooks } from 'botframework-webchat-api';
import { useCallback, useContext } from 'react';
import DruidWebchatContext, { DruidWebchatContextType } from '../WebChatContext';
import normalizeLanguage from 'botframework-webchat-api/lib/utils/normalizeLanguage';

const { useLocalizer, useLanguage } = hooks;

const useDruidLocalize = (bfLocalizer?: ReturnType<typeof useLocalizer>) => {
    const [,, getState ] = useContext<DruidWebchatContextType>(DruidWebchatContext);

    // const localize = useLocalizer();

    //const [currentLanguage] = useLanguage();
    const { locale: currentLanguage } = getState();
    return useCallback((code: string, ...args: string[]): string => {
        const { localization } = getState().mergedChatOptions;
        const normalizedLanguage = normalizeLanguage(currentLanguage);
        var ret = (bfLocalizer && bfLocalizer(code, ...args)) || (localization && ((localization[normalizedLanguage] && localization[normalizedLanguage][code]) || (localization["en-US"] && localization["en-US"][code])));
        ret = typeof ret === 'string' ? ret : '';

        return  ret;
    }, [bfLocalizer, currentLanguage, getState]);
    
}

export default useDruidLocalize;